<div class="breadcrumb_content">
  <div class="container-fluid">
    @if (breadcrumbs.length > 1) {
      <nav>
        <ol class="breadcrumb">
          <li *ngFor="let breadcrumb of breadcrumbs" class="breadcrumb-objects" [ngClass]="{ 'breadcrumb-last': isLast(breadcrumb) }">
            <a
              href="javascript:void(0)"
              [routerLink]="!isLast(breadcrumb) ? breadcrumb.url : []"
              [ngStyle]="{ color: isLast(breadcrumb) ? '#000' : '#FF1300' }"
              [ngClass]="{ 'no-cursor': isLast(breadcrumb) }"
            >
              {{ breadcrumb.label }}
            </a>
          </li>
        </ol>
      </nav>
    }
  </div>
</div>
